module.exports = __webpack_public_path__ + "img/组 2075@2x.16a339b6.png";